import { inject, injectable } from 'tsyringe';
import { NoRecommendationsReasons } from '../no-recommendations-reasons.enums';
import { ConditionContext } from './interfaces/condition-context.interface';
import { ICondition, MatchResult } from './interfaces/condition.interface';
import { RecommendationConditions } from '../../datastore-service/models/conditions.model';
import {
  conditionType,
  ConditionType,
} from './decorators/condition-type.decorator';
import { LoggerService } from '../../logger.service';
import { kDITOWWrapper } from '../../../constants/injectionTokens';
import {
  IOWWrapper,
  IPlatform,
} from '../../../interfaces/ow-wrappers/ow-wrapper.interface';

// -----------------------------------------------------------------------------
const kPlatformMap = new Map<IPlatform, RecommendationConditions>([
  ['ow', RecommendationConditions.ConditionOwEnabled],
  ['owe', RecommendationConditions.ConditionElectronEnabled],
]);

// -----------------------------------------------------------------------------
@injectable()
@conditionType(ConditionType.AppSpecific)
export class ConditionPlatformDisabled implements ICondition {
  private readonly logger = LoggerService.getCategory(
    'ConditionPlatformDisabled',
  );

  // ---------------------------------------------------------------------------
  public constructor(
    @inject(kDITOWWrapper)
    private readonly owWrapper: IOWWrapper,
  ) {}

  // ---------------------------------------------------------------------------
  // ICondition
  // ---------------------------------------------------------------------------

  // ---------------------------------------------------------------------------
  public get id(): string {
    return this.logger.name;
  }

  // ---------------------------------------------------------------------------
  async match(context: ConditionContext): Promise<MatchResult> {
    const { application } = context;

    const platform = this.owWrapper.getPlatform();
    const hasCondition = application.appConditions.includes(
      kPlatformMap.get(platform),
    );

    const reason = hasCondition
      ? null
      : NoRecommendationsReasons.PlatformDisabled;

    return [hasCondition, reason];
  }
}
